import FileSaver from 'file-saver'; 
import { Document, Packer, Paragraph, TextRun, HeadingLevel,
    AlignmentType,Table, TableCell, TableRow, WidthType } from 'docx';
import { saveDocument } from './savePTODoc';
import { document } from '~/api';

export const generateDocument = async (allData = {}, titleOpinionId = 0, isPrintOnly = true) => {
    //console.log('generateDocument...' + JSON.stringify(allData.restrictiveCovenantsData));
    const { 
        propertyInfoData, 
        taxesData, 
        restrictiveCovenantsData, 
        recordedPlatData, 
        liensMortgagesDeedsData, 
        titleInsuraceApplicationData,
        easementsRightofWayData,
        additionalInformationData,
        reviewData 
    } = allData;
    const propertySectionData = Object.prototype.hasOwnProperty.call(propertyInfoData.section, '_data') ? JSON.parse(propertyInfoData.section._data) : {};
    const taxesSectionData = Object.prototype.hasOwnProperty.call(taxesData.section, '_data') ? JSON.parse(taxesData.section._data) : {};
    const restrictiveCovenantsSectionData = Object.prototype.hasOwnProperty.call(restrictiveCovenantsData.section, '_data') ? JSON.parse(restrictiveCovenantsData.section._data) : {};
    const restrictiveConventsConditions = restrictiveCovenantsSectionData?.restrictiveCovenants;
    const recordedPlatSectionData = Object.prototype.hasOwnProperty.call(recordedPlatData.section, '_data') ? JSON.parse(recordedPlatData.section._data) : {};
    const additionalInformationSectionData = Object.prototype.hasOwnProperty.call(additionalInformationData.section, '_data') ? JSON.parse(additionalInformationData.section._data) : {};
    const titleInsuraceApplicationSectionData = Object.prototype.hasOwnProperty.call(titleInsuraceApplicationData.section, '_data') ? JSON.parse(titleInsuraceApplicationData.section._data) : {};
    const reviewDataSectionData = Object.prototype.hasOwnProperty.call(reviewData.section, '_data') ? JSON.parse(reviewData.section._data) : {};

    const propertDataObj = extractPropertyData(propertySectionData);
    const taxesDataObj = extractTaxesData(taxesSectionData);

    //console.log('additionalInformationSectionData...' + JSON.stringify(additionalInformationSectionData));

    const hasSameAsOwner = Object.prototype.hasOwnProperty.call(titleInsuraceApplicationSectionData, 'sameAsOwner') ? titleInsuraceApplicationSectionData?.sameAsOwner : false;
    const requiredALTAPrimaryArr = Array.isArray(titleInsuraceApplicationSectionData?.requiredALTAPrimary) && titleInsuraceApplicationSectionData?.requiredALTAPrimary.map(x => x.label);
    const requiredALTAPrimaryData = Array.isArray(titleInsuraceApplicationSectionData?.requiredALTAPrimary) ? requiredALTAPrimaryArr.join() : titleInsuraceApplicationSectionData?.requiredALTAPrimary?.label;
    const requiredALTASecondaryArr = Array.isArray(titleInsuraceApplicationSectionData?.requiredALTASecondary) && titleInsuraceApplicationSectionData?.requiredALTASecondary.map(x => x.label);
    const requiredALTASecondaryData = Array.isArray(titleInsuraceApplicationSectionData?.requiredALTASecondary) ? requiredALTASecondaryArr.join() : titleInsuraceApplicationSectionData?.requiredALTASecondary?.label;

    const currentOwnerTable = populateCurrentOwner(propertyInfoData.sectionDetails);
    const nonIndividualOwnerTable = populateNonIndividualOwner(propertyInfoData.sectionDetails);
    const propertyAddressTable = populatePropertyAddress(propertySectionData);
    const bookReferencesTable = populateBookReferences(restrictiveCovenantsData.sectionDetails);
    const buildingSetBackLinesTable = populateBuildingSetBackLinesTable(restrictiveCovenantsSectionData);
    const bookReferencesPlatTable = populateBookReferencesPlat(recordedPlatData.sectionDetails);
    const buildingSetBackLinesPlatTable = populateBuildingSetBackLinesPlatTable(recordedPlatSectionData);
    const deedsOfTrustTable = populateDeedsOfTrust(liensMortgagesDeedsData.sectionDetails);
    const easementsRightofWayTable = populateEasementRightOfWay(easementsRightofWayData?.sectionDetails);
    const insuredOwnersTable = hasSameAsOwner ? currentOwnerTable : populateInsuredOwners(titleInsuraceApplicationData.sectionDetails);
    const nonIndividualInsuredOwnerTable = hasSameAsOwner ? nonIndividualOwnerTable : populateNonIndividualInsuredOwners(titleInsuraceApplicationData.sectionDetails);
    const lenderTable = populateLenders(titleInsuraceApplicationData.sectionDetails);
    const lenderSecondLienTable = populateLenderSecondLien(titleInsuraceApplicationData.sectionDetails);

    const doc = new Document({
        sections: [{
            properties: {},
            children: [
                new Paragraph({
                    children: [new TextRun({
                        text: 'ATTORNEY’S PRELIMINARY TITLE OPINION',
                        bold: true,
                        allCaps: true,
                        font: 'Arial-BoldMT',
                        size: 34
                    })],
                    heading: HeadingLevel.TITLE,
                    alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                    children: 
                    [new TextRun({
                        text: 'Title Company: ',
                        bold: true,
                        allCaps: true,
                        font: 'Arial-BoldMT',
                        size: 16
                    }),
                    new TextRun({
                        text:  propertDataObj?.titleCompany,
                        bold: false,
                        allCaps: true,
                        font: 'Arial-BoldMT',
                        size: 15
                    })
                    ],
                    heading: HeadingLevel.TITLE,
                    alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Transaction Type: ',
                            bold: true,
                            allCaps: true,
                            font: 'Arial-BoldMT',
                            size: 16
                        }),
                        new TextRun({
                            text: propertDataObj?.transactionType,
                            bold: false,
                            allCaps: true,
                            font: 'Arial-BoldMT',
                            size: 15
                        })
                    ],
                    heading: HeadingLevel.TITLE,
                    alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Cash Sale: ',
                            bold: true,
                            allCaps: true,
                            font: 'Arial-BoldMT',
                            size: 16
                        }),
                        new TextRun({
                            text: propertDataObj?.cashSale ? "Yes" : "No",
                            bold: false,
                            allCaps: false,
                            font: 'Arial-BoldMT',
                            size: 15
                        })
                    ],
                    heading: HeadingLevel.TITLE,
                    alignment: AlignmentType.CENTER,
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'This opinion of title is for the parties to whom it is furnished, is not transferable, and may not be used by any other person or entity without the prior written consent of the undersigned: ',
                        bold: true,
                        font: 'Arial-BoldMT',
                    })],
                    alignment: AlignmentType.LEFT,
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'CURRENT OWNERS:',
                        bold: true,
                        allCaps: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                currentOwnerTable,
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Non Individual Owner(s) :',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                nonIndividualOwnerTable,
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'PROPERTY ADDRESS:',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                propertyAddressTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Interest or Estate: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: propertDataObj?.interestOrEstate?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Legal Description: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: propertDataObj?.notes,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'TAXES & SPECIAL ASSESSMENTS:',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Taxes have been paid through and including those for the year: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: taxesDataObj?.taxesPaidThrough,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Taxes now due or payable: ',
                            bold: true
                        }),
                        new TextRun({
                            text: taxesDataObj?.taxesNowDuePayable,
                            bold: false
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Taxes, a lien, deferred or otherwise, but not yet due and payable: ',
                            bold: true
                        }),
                        new TextRun({
                            text: taxesDataObj?.taxesNotDue,
                            bold: false
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Parcel ID/PIN/Tax Map ID: ',
                            bold: true
                        }),
                        new TextRun({
                            text: taxesDataObj?.taxID,
                            bold: false
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'RESTRICTIVE COVENANTS AND CONDITIONS:',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Restrictive Convents and Conditions ?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: restrictiveConventsConditions,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Please list Book & Page reference(s): ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                bookReferencesTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Does Survey And/Or Public Record Indicate A Violation?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: restrictiveCovenantsSectionData?.violation,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Contain A Reversionary Or Forfeiture Clause?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: restrictiveCovenantsSectionData?.forfeiture,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Building setback line(s): ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                buildingSetBackLinesTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Easements/Other Matters: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: restrictiveCovenantsSectionData?.easementsOthers,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Survey & Inspection Report Attached?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: restrictiveCovenantsSectionData?.reportAttached,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Recorded Plat: ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Recorded Plat?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: recordedPlatSectionData?.recordedPlat,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Please list Book & Page reference(s): ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                bookReferencesPlatTable,
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Building setback line(s): ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                buildingSetBackLinesPlatTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Violated?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: Object.prototype.hasOwnProperty.call(recordedPlatSectionData, 'violation') ? recordedPlatSectionData?.violation : '',
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Easements/Other Matters: ',
                            bold: true,
                        }),
                        new TextRun({
                            text:  recordedPlatSectionData?.easementsOthers,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Access To Public Right Of Way?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: recordedPlatSectionData?.accessToPublicRightOfWay || 'No',
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Access To Public Right Of Way Type: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: recordedPlatSectionData?.accessType,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'If Over A Private Easement, Has A Search Been Made Of Adjoining Property On Which Easement Crosses? : ',
                            bold: true,
                        }),
                        new TextRun({
                            text: Object.prototype.hasOwnProperty.call(recordedPlatSectionData, 'accessType') && recordedPlatSectionData?.accessType.toLowerCase() == 'direct' ? '' : recordedPlatSectionData?.searchAdjoiningProperty,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Property Occupied By: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.propertyOccupiedBy?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Updating From Previous Title Insurance Policy?: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.updateFromPrevious,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Deeds of Trust, Liens, Easements. Etc.  ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                deedsOfTrustTable,
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Easements and Rights of Way  ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                easementsRightofWayTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Additional Information: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData.additionalInformation,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'The Search Period Was:  ',
                        bold: true,
                    })],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'From:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: isValidDate(new Date(additionalInformationSectionData.fromSearchPeriod)) ? new Date(additionalInformationSectionData.fromSearchPeriod).toLocaleDateString() : '',
                        }),
                        new TextRun({
                            text: '   ',
                        }),
                        new TextRun({
                            text: ' To:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: isValidDate(new Date(additionalInformationSectionData.throughSearchPeriod)) ? new Date(additionalInformationSectionData.throughSearchPeriod).toLocaleDateString() : '',
                            bold: false,
                        }),
                        new TextRun({
                            text: '   ',
                        }),
                        new TextRun({
                            text: ' At  ',
                        }),
                        new TextRun({
                            text: isValidDate(new Date(additionalInformationSectionData.atSearchPeriod)) ? new Date(additionalInformationSectionData.atSearchPeriod).toLocaleTimeString() : '',
                            bold: false,
                        }),
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Title Insurance Application:',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.CENTER
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Homeowners Policy?  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.issueHomeownersPolicy ? 'Yes': 'No',
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Purchase Price:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.ownerInsuranceCoverageAmount,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Insured: ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                insuredOwnersTable,
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Non Individual Insured:  ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                nonIndividualInsuredOwnerTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Use of Property:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: propertySectionData?.useOfProperty?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Lenders Insurance Coverage Amount: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.lenderInsuranceCoverageAmount,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Is this a Private Lender?  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.isPrivateLender,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                lenderTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Mortgagee Clause: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.mortgageClausePrimary?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Loan Type: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.loanTypePrimary?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Loan Number: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.loanNumberPrimary,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'The following ALTA Endorsements are requested: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: requiredALTAPrimaryData,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Is a Closing Protection Letter Required? ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.isClosingProtectionLetterRequired,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: '2nd Lien: ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Lenders Insurance Coverage Amount:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.lenderInsuranceCoverageAmountSecondary,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Is this a Private Lender? ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.isPrivateLenderSecondary,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                lenderSecondLienTable,
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Mortgagee Clause: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.mortgageClauseSecondary?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Loan Type: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.loanTypeSecondary?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Loan Number: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.loanNumberSecondary,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'The following ALTA Endorsements are requested: ',
                            bold: true,
                        }),
                        new TextRun({
                            text: requiredALTASecondaryData,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Is a Closing Protection Letter Required?  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.isClosingProtectionLetterRequiredSecondary,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Do you need a separate commitment for this lien?  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: titleInsuraceApplicationSectionData?.separateCommittment,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [new TextRun({
                        text: 'Additional Information: ',
                        bold: true,
                    })],
                    heading: HeadingLevel.HEADING_3,
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Is a mobile or manufactured home located on the property?  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.mobileHome,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Do you request that the policy include coverage for any mobile or manufactured home as part of the insured land?  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.includeMobileHomeCoverage,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Declaration of intent to affix or the MVR46G recording information: Book  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.book,
                            bold: false,
                        }),
                        new TextRun({text: '  '}),
                        new TextRun({
                            text: ' Page  ',
                            bold: true,
                        }), 
                        new TextRun({
                            text: additionalInformationSectionData?.page,
                            bold: false,
                        }),
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({}),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Is construction on the property in progress or immediately contemplated or has construction been recently completed?   ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.constructionInProgress,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Has a Mechanics’ Lien Agent been appointed? ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.mechanicsLienAgent,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Lien Agent Name:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: additionalInformationSectionData?.lienAgentName,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
                new Paragraph({
                    children: [
                        new TextRun({
                            text: 'Certifying Attorney\'s Signature:  ',
                            bold: true,
                        }),
                        new TextRun({
                            text: reviewDataSectionData?.attorney?.label,
                            bold: false,
                        })
                    ],
                    alignment: AlignmentType.LEFT
                }),
            ],
        }]
    });

    try {
        if(isPrintOnly) {
            Packer.toBlob(doc).then(blob => {
                FileSaver.saveAs(blob, 'PTO Document.docx');
            });
        } else {
            return Packer.toBlob(doc).then(blob => {
                //download file
                FileSaver.saveAs(blob, 'PTO Document.docx');

                //save file to server
                const description = 'PTO Document for title opinion id: ' + titleOpinionId;
                let blobToFile = blob;
                blobToFile.lastModifiedDate = new Date();
                blobToFile.name = 'PTO Document.docx';
                let _file = {
                    file: blobToFile,
                    uploadLink: {},
                    uploadInfo: {},
                    isDeleted: false,
                    type: document.DocumentType.PTO_WORD_DOC,
                    uploaded: false
                };
                return saveDocument(_file, description, titleOpinionId, document.DocumentType.PTO_WORD_DOC);   
            });
        }
    }
    catch(err) {
        console.error(err);
    }
};

function extractPropertyData(data  = {}) {
    return {
        titleCompany: Object.prototype.hasOwnProperty.call(data, 'titleCompany') ? data?.titleCompany?.label : '',
        transactionType: Object.prototype.hasOwnProperty.call(data, 'transactionType')  ? data?.transactionType?.label : '',
        cashSale: Object.prototype.hasOwnProperty.call(data, 'cashSale') ? data?.cashSale : '',
        interestOrEstate: Object.prototype.hasOwnProperty.call(data, 'interestOrEstate') ? data?.interestOrEstate : '',
        notes: Object.prototype.hasOwnProperty.call(data, 'notes') ? data?.notes : ''
    };
}

function extractTaxesData(data = {}) {
    return {
        taxesPaidThrough: Object.prototype.hasOwnProperty.call(data, 'taxesPaidThrough') ? data['taxesPaidThrough'] : '',
        taxesNowDuePayable: Object.prototype.hasOwnProperty.call(data, 'taxesNowDuePayable') ? data.taxesNowDuePayable : '',
        taxesNotDue: Object.prototype.hasOwnProperty.call(data, 'taxesNotDue') ? data['taxesNotDue'] : '',
        taxID: Object.prototype.hasOwnProperty.call(data, 'parcelId')  ? data['parcelId'] : '',
    };
}

function populateCurrentOwner(data=[])  {
    try {
        const sectionData = data;

        //console.log('populateCurrentOwner:: ' + JSON.stringify(data));
        let tableColumns = ['First','Middle','Last','Suffix','Relationship','First','Middle','Last','Suffix'];
        let tableHeaderCellData = createTableCells(tableColumns, true);
        const tableRowHeader = new TableRow({
            children: tableHeaderCellData,
        });
    
        let rowsInfo = sectionData && sectionData.filter((x) => x?._data?.ownerPrimaryType?.value.toLowerCase() == 'individual')
            .map((data) => {
                /*
                    owner can be individual or entity
                */
                let rowData = [];
                rowData.push(data?._data?.ownerPrimary?.ownerFirstName);
                rowData.push(data?._data?.ownerPrimary?.ownerMiddleName);
                rowData.push(data?._data?.ownerPrimary?.ownerLastName);
                rowData.push(data?._data?.ownerPrimary?.ownerSuffix);

                rowData.push(data?._data?.relationship?.label);
        
                rowData.push(data?._data?.ownerSecondary?.ownerFirstName);
                rowData.push(data?._data?.ownerSecondary?.ownerMiddleName);
                rowData.push(data?._data?.ownerSecondary?.ownerLastName);
                rowData.push(data?._data?.ownerSecondary?.ownerSuffix);
        
                let rowCellsData = createTableCells(rowData, false);
        
                return new TableRow({
                    children: rowCellsData
                });
            });
    
        rowsInfo.unshift(tableRowHeader);
        let currentOwnerTable = new Table({
            columnWidths: [4505, 4505],
            rows: rowsInfo,
        });
        return currentOwnerTable;
    }
    catch(err) {
        console.error(err);
    }
}

function populateNonIndividualOwner( data = []) {
    const sectionData = data;
    //console.log('populateNonIndividualOwner' + JSON.stringify(data));

    let rowsInfo = sectionData && sectionData.map((data) => {
        let ownerType =  data?._data?.ownerPrimaryType?.label;
        if(ownerType.toLowerCase() !== 'individual') {
            return new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: 4505,
                            type: WidthType.DXA,
                        },
                        children: [new Paragraph({
                            children: [new TextRun({
                                text: data?._data?.ownerPrimary?.ownerEntityName,
                                bold: false,
                            })]
                        })],
                    }),
                    new TableCell({
                        width: {
                            size: 4505,
                            type: WidthType.DXA,
                        },
                        children: [new Paragraph({
                            children: [new TextRun({
                                text: data?._data?.ownerPrimary?.ownerEntityType?.label,
                            })]
                        })],
                    }),
                ],
            });
        }
    })
        .filter((data)=> data !== undefined);

    const tableRowHeader = new TableRow({
        children: [
            new TableCell({
                width: {
                    size: 4505,
                    type: WidthType.DXA,
                },
                children: [new Paragraph({
                    children: [new TextRun({
                        text: 'Non Individual(s)',
                        bold: true,
                    })]
                })],
            }),
            new TableCell({
                width: {
                    size: 4505,
                    type: WidthType.DXA,
                },
                children: [new Paragraph({
                    children: [new TextRun({
                        text: 'Entity Type',
                        bold: true
                    })]
                })],
            }),
        ],
    });
    
    rowsInfo.unshift(tableRowHeader);
    let nonIndividualOwnerTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsInfo,
    });
    return nonIndividualOwnerTable;
}
    


function populatePropertyAddress(data = {}) {

    let tableColumns = ['Street Address','ZIP','City','State','County'];
    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });

    let rowsData = [];
    rowsData.push(Object.prototype.hasOwnProperty.call(data, 'street') ? data?.street : '');
    rowsData.push(Object.prototype.hasOwnProperty.call(data, 'zipcode') ? data?.zipcode : '');
    rowsData.push(Object.prototype.hasOwnProperty.call(data, 'city') ? data?.city : '');
    rowsData.push(Object.prototype.hasOwnProperty.call(data, 'state') ? data?.state?.label : '');
    rowsData.push(Object.prototype.hasOwnProperty.call(data, 'county') ? data?.county : '');
    let rowsCellData = createTableCells(rowsData);
    let rows = new TableRow({
        children: rowsCellData
    });

    let propertyTable = new Table({
        columnWidths: [4505, 4505],
        rows: [headerRow,rows],
    });

    return propertyTable;
}

function createTableCells(data, isBold = false) {
    return data.map((val) => {
        return new TableCell({
            width: {
                size: 4505,
                type: WidthType.DXA,
            },
            children: [new Paragraph({
                children: [new TextRun({
                    text: val,
                    bold: isBold,
                })],
            })],
        });
    });
}

function populateBookReferences(sectionDetails = []) {
    let tableColumns = ['Book','Page Number'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });

    let rowsData = sectionDetails && sectionDetails.map((d) => {
        let book = d?._data?.book;
        let pageNo = d?._data?.pageNo;
        let rowData = [];
        rowData.push(book);
        rowData.push(pageNo);

        let rowCellsData = createTableCells(rowData, false);
    
        return new TableRow({
            children: rowCellsData
        });
    });

    rowsData.unshift(headerRow);

    let bookReferenceTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsData,
    });

    return bookReferenceTable;
}

function populateBuildingSetBackLinesTable(data = {}) {
    //TODO: populate row data
    let tableColumns = ['Feet From Front','Feet From Side','Feet from Side Street','Feet From Rear'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });

    let rowsData = [];
    rowsData.push(data?.feetFromFront);
    rowsData.push(data?.feetFromSide);
    rowsData.push(data?.feetFromSideStreet);
    rowsData.push(data?.feetFromRear);
    let rowsCellData = createTableCells(rowsData);
    let rows = new TableRow({
        children: rowsCellData
    });

    let buildingSetBacklinesTable = new Table({
        columnWidths: [4505, 4505],
        rows: [headerRow,rows],
    });

    return buildingSetBacklinesTable;
}

function populateBookReferencesPlat(sectionDetails=[]) {
    //TODO: populate row data
    let tableColumns = ['Book','Page Number'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });
    
    let rowsInfo = sectionDetails && sectionDetails.map((d) => {
        let book = d?._data?.book;
        let pageNo = d?._data?.pageNo;
        let rowData = [];
        rowData.push(book);
        rowData.push(pageNo);

        let rowCellsData = createTableCells(rowData, false);
    
        return new TableRow({
            children: rowCellsData
        });
    });

    rowsInfo.unshift(headerRow);
    
    let bookReferencePlatTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsInfo,
    });
    
    return bookReferencePlatTable;
}

function populateBuildingSetBackLinesPlatTable(data = {}) {
    //TODO: populate row data
    let tableColumns = ['Feet From Front','Feet From Side','Feet from Side Street','Feet From Rear'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });
    
    let rowsData = [];
    rowsData.push(data?.feetFromFront);
    rowsData.push(data?.feetFromSide);
    rowsData.push(data?.feetFromSideStreet);
    rowsData.push(data?.feetFromRear);
    let rowsCellData = createTableCells(rowsData);
    let rows = new TableRow({
        children: rowsCellData
    });
    
    let buildingSetBacklinesTable = new Table({
        columnWidths: [4505, 4505],
        rows: [headerRow,rows],
    });
    
    return buildingSetBacklinesTable;
}

function populateDeedsOfTrust(sectionDetails = []) {
    //TODO: populate row data
    let tableColumns = ['Lien Type','Action to be taken','Trustee','In favor of','Dated','Recorded date','Book','Page','County Registry','Instrument Number','Amount'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });
    

    let rowsData = sectionDetails && sectionDetails.map((d) => {
        let lienType = d?._data?.lienType?.value === 'Other' ? d?._data?.otherLienType : d?._data?.lienType?.value;
        let action = d?._data?.action?.value;
        let trustee = d?._data?.trustee;
        let inFavorOf = d?._data?.inFavorOf;
        let dated = d?._data?.dated !== null ? new Date( d?._data?.dated) : '';
        let recordDate = d?._data?.recordDate !== null ? new Date(d?._data?.recordDate) : '';
        let book = d?._data?.book;
        let pageNo = d?._data?.pageNo;
        let countyRegistry = d?._data?.countyRegistry;
        let instrumentNo = d?._data?.instrumentNo;
        let amount = d?._data?.amount;

        dated = isValidDate(dated) ? new Date(dated).toLocaleDateString() : '';
        recordDate = isValidDate(recordDate) ? new Date(recordDate).toLocaleDateString() : '';

        let row_data = [];
        row_data.push(lienType);
        row_data.push(action);
        row_data.push(trustee);
        row_data.push(inFavorOf);
        row_data.push(dated);
        row_data.push(recordDate);
        row_data.push(book);
        row_data.push(pageNo);
        row_data.push(countyRegistry);
        row_data.push(instrumentNo);
        row_data.push(amount);

        let rowCellsData = createTableCells(row_data, false);
    
        return new TableRow({
            children: rowCellsData
        });
    });

    rowsData.unshift(headerRow);
    
    let deedsOfTrustTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsData,
    });
    
    return deedsOfTrustTable;
}

function populateEasementRightOfWay(sectionDetails = []) {
    let tableColumns = ['Exception Type','In Favor Of','Book','Page','County Registry '];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });

    let rowsData = sectionDetails && sectionDetails.map((d) => {
        let exceptionType = d?._data?.lienType?.label === 'Other' ? d?._data?.otherLienType : d?._data?.lienType?.value;
        let inFavorOf = d?._data?.inFavorOf;
        let book = d?._data?.book;
        let page = d?._data?.pageNo;
        let countyRegistry = d?._data?.countyRegistry;

        let row_data = [];
        row_data.push(exceptionType);
        row_data.push(inFavorOf);
        row_data.push(book);
        row_data.push(page);
        row_data.push(countyRegistry);

        let rowCellsData = createTableCells(row_data, false);
    
        return new TableRow({
            children: rowCellsData
        });
    });

    rowsData.unshift(headerRow);
    
    let easementRightOfWayTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsData,
    });
    
    return easementRightOfWayTable;
}

function populateInsuredOwners(sectionDetails = []) {
    let tableColumns = ['First','Middle','Last','Suffix','Relationship','First','Middle','Last','Suffix'];
    let tableHeaderCellData = createTableCells(tableColumns, true);
    const headerRow = new TableRow({
        children: tableHeaderCellData,
    });

    let rowsInfo = sectionDetails && sectionDetails.filter((d) => d?._data?.type.toLowerCase() == 'insured').map((d) => {
        let _type = d?._data?.type;
        if(_type.toLowerCase() == 'insured') {
            let row_data = [];
            if(d?._data?.insuredPrimaryType.label.toLowerCase()=='individual') {
                row_data.push(d?._data?.insuredPrimary?.insuredFirstName);
                row_data.push(d?._data?.insuredPrimary?.insuredMiddleName);
                row_data.push(d?._data?.insuredPrimary?.insuredLastName);
                row_data.push(d?._data?.insuredPrimary?.insuredSuffix);
            }   else {
                row_data.push('');
                row_data.push('');
                row_data.push('');
                row_data.push('');
            }
            row_data.push(d?._data?.relationship?.value == '' ? '' : d?._data?.relationship?.label);
            if(d?._data?.insuredSecondaryType.label.toLowerCase()=='individual') {
                row_data.push(d?._data?.insuredSecondary?.insuredFirstName);
                row_data.push(d?._data?.insuredSecondary?.insuredMiddleName);
                row_data.push(d?._data?.insuredSecondary?.insuredLastName);
                row_data.push(d?._data?.insuredSecondary?.insuredSuffix);
            } else {
                row_data.push('');
                row_data.push('');
                row_data.push('');
                row_data.push('');
            }
            
            
            let rowCellsData = createTableCells(row_data, false);
    
            return new TableRow({
                children: rowCellsData
            });
        }
    });

    rowsInfo.unshift(headerRow);
    
    let insuredOwnersTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsInfo,
    });
    
    return insuredOwnersTable;
}

function populateNonIndividualInsuredOwners(sectionDetails = []) {
    //TODO: populate row data
    let tableColumns = ['Non Individual(s)','Relationship'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });

    let rowsInfo = sectionDetails && sectionDetails
        .filter((d) => d?._data?.type.toLowerCase() == 'insured' && d?._data?.insuredPrimaryType?.label.toLowerCase() == 'entity')
        .map((d) => {
            let row_data = [];
            row_data.push(d?._data?.insuredPrimary?.insuredEntityName);
            row_data.push(d?._data?.insuredPrimary?.insuredEntityType?.label);

            let rowCellsData = createTableCells(row_data, false);
        
            return new TableRow({
                children: rowCellsData
            });
        });

    rowsInfo.unshift(headerRow);
     
    let nonIndividualInsuredTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsInfo,
    });
     
    return nonIndividualInsuredTable;
}

function populateLenders(sectionDetails = []) {
    //TODO: populate row data
    let tableColumns = ['Lender','Street','City','State','ZIP'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });

    let rowsInfo = sectionDetails && sectionDetails.filter((d) => d?._data?.type.toLowerCase() == 'lenderprimary').map((d) => {
        let row_data = [];
        row_data.push(d?._data?.lenderDetailData?.lenderName);
        row_data.push(d?._data?.lenderDetailData?.lenderStreetAddress);
        row_data.push(d?._data?.lenderDetailData?.lenderCity);
        row_data.push(d?._data?.lenderDetailData?.lenderState);
        row_data.push(d?._data?.lenderDetailData?.lenderZip);
        let rowCellsData = createTableCells(row_data, false);
    
        return new TableRow({
            children: rowCellsData
        });
    });

    rowsInfo.unshift(headerRow);
         
    let lendersTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsInfo,
    });
         
    return lendersTable;
}

function populateLenderSecondLien(sectionDetails = []) {
    //TODO: populate row data
    let tableColumns = ['Lender','Street','City','State','ZIP'];

    let headerRowCellData = createTableCells(tableColumns, true);
    let headerRow = new TableRow({
        children: headerRowCellData
    });
    
    let rowsInfo = sectionDetails && sectionDetails.filter((d) => d?._data?.type.toLowerCase() == 'lendersecondary').map((d) => {
        let row_data = [];
        row_data.push(d?._data?.lenderDetailData?.lenderName);
        row_data.push(d?._data?.lenderDetailData?.lenderStreetAddress);
        row_data.push(d?._data?.lenderDetailData?.lenderCity);
        row_data.push(d?._data?.lenderDetailData?.lenderState);
        row_data.push(d?._data?.lenderDetailData?.lenderZip);
        let rowCellsData = createTableCells(row_data, false);
    
        return new TableRow({
            children: rowCellsData
        });
    });

    rowsInfo.unshift(headerRow);

    let lendersTable = new Table({
        columnWidths: [4505, 4505],
        rows: rowsInfo,
    });
         
    return lendersTable;
}

function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}